import swal from "sweetalert";

document.addEventListener("DOMContentLoaded", () => {
	$.nette.ext("product-added-alert", {
		success: function (e) {
			if (e.hasOwnProperty("showProductAdded")) {
				swal({
					title: e.showProductAdded,
					icon: "success",
					button: {
						text: "OK",
						className: "btn btn-secondary",
						closeModal: true,
						value: true,
						visible: true
					},
					closeOnEsc: true,
					closeOnClickOutside: true,
					timer: 2000
				});

				if (typeof window.fbq !== "undefined" && e.hasOwnProperty("productCode") && e.hasOwnProperty("productCount")) {
					window.fbq("track", "AddToCart", {
						contents: [{
							id: e.productCode,
							quantity: e.productCount
						}],
						content_type: "product"
					});
				}

				if (
					typeof window.gtag !== "undefined" &&
					e.hasOwnProperty("productCode") &&
					e.hasOwnProperty("productCount") &&
					e.hasOwnProperty("productPrice") &&
					e.hasOwnProperty("productName")
				) {
					window.gtag("event", "add_to_cart", {
						"currency": "CZK",
						"value": e.productPrice,
						"items": [{
							"item_id": e.productCode,
							"item_name": e.productName,
							"price": e.productPrice,
							"quantity": e.productCount,
							"google_business_vertical": "retail"
						}],
					});
				}
			}

			if (e.hasOwnProperty("totalCartProducts")) {
				const total = e.totalCartProducts;

				$(".total-cart-products").html(total);

				if (total >= 10) {
					$(".total-cart-products-10").removeClass("d-none");
					$(".total-cart-products-1").addClass("d-none");
				} else {
					$(".total-cart-products-10").addClass("d-none");
					$(".total-cart-products-1").removeClass("d-none");
				}
			}

			if (e.hasOwnProperty("wishlistProductId")) {
				const wishlistProductId = e.wishlistProductId;

				$("#add-to-wishlist-" + wishlistProductId).find("i").removeClass("mdi-heart-outline").addClass("mdi-heart");
			}
		}
	});
});
